module.exports = "<div class=\"download-progress\"  [class.show]=\"isDownloading\">\n  <div class=\"progress-container\">\n    <div class=\"spinner\" *ngIf=\"isDownloading\"> <!-- Icon tải xuống -->\n      <i class=\"fa fa-download\"></i>\n    </div>\n    <div class=\"badge\" *ngIf=\"isDownloading\" [class.animate]=\"isAnimating\">{{ downloadCount }}</div> <!-- Chấm với số lượng -->\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/process/download/download.component.html
// module id = ./src/app/components/process/download/download.component.html
// module chunks = main